<script>

    import RegisterUserContentComponent from "./RegisterUserContentComponent.svelte";
    import {getContext} from "svelte";

    const { open } = getContext('simple-modal');

    export let model_root;
    export let hash;

    open(RegisterUserContentComponent, {
        model_root: model_root,
        hash: hash
    }, {
        closeButton: false,
        closeOnEsc: false,
        closeOnOuterClick: false,
        transitionBgProps: {
            duration: 0
        },
        styleBg: { background: '#073c49' },
        styleWindow: { background: '#ffffff', padding: '10px' },
    }, {
        onClosed: () => {  }
    });

</script>

